import { forwardRef, type Ref, type SVGProps } from "react";

function SvgChatFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 2C6.477 2 2 6.477 2 12a10 10 0 0 0 .827 3.987c.096.221.109.44.053.62l-.775 2.512c-.529 1.712 1.057 3.324 2.777 2.824l2.654-.771a.9.9 0 0 1 .595.052c1.19.5 2.499.776 3.869.776 5.523 0 10-4.477 10-10S17.523 2 12 2"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChatFilled);
export default ForwardRef;
